// extracted by mini-css-extract-plugin
export default {"card":"Card_card__2yZVA","header":"Card_header__sVAG7","body":"Card_body__hOmOX","footer":"Card_footer__e49Li"};